import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

interface InitialSate {
  orderId?: number
}

const initialState: InitialSate = {
  orderId: undefined,
}

const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    setOrderId(state, action: PayloadAction<number | undefined>) {
      state.orderId = action.payload
    },
  },
})

export const ordersActions = ordersSlice.actions
export const ordersReducer = ordersSlice.reducer
